import ImportService, { TermsByKey, TranslationsByTermId } from "./ImportService";

/**
 * Loads the project's terms and each language's translations once, and shares them between previews and imports.
 * Concurrent requests for the same data share one request; a failed load is retried on the next call.
 */
class ImportDataCache {
  private termsPromise: Promise<TermsByKey> | null = null;

  private translationsPromises = new Map<string, Promise<TranslationsByTermId>>();

  constructor(private projectId: string, private importService: ImportService) {}

  getTerms(): Promise<TermsByKey> {
    if (!this.termsPromise) {
      const promise = this.importService.loadTerms(this.projectId);
      this.termsPromise = promise;
      promise.catch(() => {
        if (this.termsPromise === promise) this.termsPromise = null;
      });
    }
    return this.termsPromise;
  }

  getTranslations(languageCode: string): Promise<TranslationsByTermId> {
    const code = languageCode.toLowerCase();
    let promise = this.translationsPromises.get(code);
    if (!promise) {
      const newPromise = this.importService.loadTranslations(this.projectId, code);
      promise = newPromise;
      this.translationsPromises.set(code, newPromise);
      newPromise.catch(() => {
        if (this.translationsPromises.get(code) === newPromise) this.translationsPromises.delete(code);
      });
    }
    return promise;
  }

  clear() {
    this.termsPromise = null;
    this.translationsPromises.clear();
  }
}

export default ImportDataCache;
